<template>
  <div/>
</template>

<script setup lang="ts">
import { watch } from 'vue';
import { useStore } from 'vuex';
import { latestMessage, type WebSocketMessageWithFields } from '@/plugins/ws';

import {RootState} from "@/store";

const store = useStore<RootState>();

defineOptions({
  name: 'dataMath',
});

// Типы для WebSocket сообщений компонента math
type MathSettingsMessage = WebSocketMessageWithFields<'indicator-list' | 'indicator-root' | 'indicator-param-list' | 'indicator-out-list' | 'indicator-set-list', {
  math: unknown;
  types: unknown;
}>;

// Объединенный тип для всех сообщений
type MathWebSocketMessage = MathSettingsMessage;

// WebSocket message handler
const handleWebSocketMessage = (data: MathWebSocketMessage): void => {
  if (!data?.signal) return;

  switch (data.signal) {
    case 'indicator-list':
    case 'indicator-root':
    case 'indicator-param-list':
    case 'indicator-out-list':
    case 'indicator-set-list':
      store.dispatch('indicators/wsSetMathSettings', {
        math: data.math,
        types: data.types,
      });
      break;
  }
};

watch(latestMessage, handleWebSocketMessage);
</script>
